import { IWorkerCustomField } from 'types/profileCustomFields';

const mergeField = (fieldMap: { companyFields: IWorkerCustomField[]; projectFields: IWorkerCustomField | null }) => {
  const { companyFields, projectFields } = fieldMap;

  const getValue = (key: string) => {
    let value = projectFields?.[key] || null;
    if (value) {
      return value;
    }
    for (let i = 0; i < companyFields.length; i++) {
      value = value || companyFields[i][key];
      if (value) {
        return value;
      }
    }
    return value;
  };

  const getLowestValue = (key: string) => {
    let lowestValue = projectFields?.[key] || 0;
    for (let i = 0; i < companyFields.length; i++) {
      if (companyFields[i][key] != null && companyFields[i][key] < lowestValue) {
        lowestValue = companyFields[i][key];
      }
    }
    return lowestValue;
  };

  return {
    fieldId: companyFields[0]?.fieldId || projectFields?.fieldId || '',
    name: projectFields?.name || companyFields[0]?.name || '',
    code: projectFields?.code || companyFields[0]?.code || '',
    section: projectFields?.section || companyFields[0]?.section || '',
    dataType: projectFields?.dataType || companyFields[0]?.dataType || 0,
    isVisibleByDefault: getValue('isVisibleByDefault'),
    isVisible: getValue('isVisible'),
    isMandatoryByDefault: getValue('isMandatoryByDefault'),
    isMandatory: getValue('isMandatory'),
    isSkippableByDefault: getValue('isSkippableByDefault'),
    isSkippable: getValue('isSkippable'),
    skippableTill: getLowestValue('skippableTill'),
    canOverrideVisibleByDefault: getValue('canOverrideVisibleByDefault'),
    canOverrideMandatoryByDefault: getValue('canOverrideMandatoryByDefault'),
    canOverrideSkippableByDefault: getValue('canOverrideSkippableByDefault'),
    entityType: projectFields?.entityType || companyFields[0]?.entityType || 0,
  };
};

export const getFieldConfig = (
  allCompaniesFields: { companyId: string; workerProfileFieldsList: IWorkerCustomField[] }[],
  projectFields: IWorkerCustomField[],
  selectedCompnies: string[],
) => {
  const fieldsMap = {};

  allCompaniesFields.forEach(company => {
    if (selectedCompnies.includes(company.companyId)) {
      const workerProfileFieldsList = company.workerProfileFieldsList;
      workerProfileFieldsList.forEach(field => {
        if (!fieldsMap[field.code]) {
          fieldsMap[field.code] = {
            companyFields: [],
            projectFields: projectFields.find(pf => pf.code === field.code) || null,
          };
        }
        fieldsMap[field.code].companyFields.push(field);
      });
    }
  });
  const mergedFields = [];
  Object.keys(fieldsMap).forEach(key => {
    mergedFields.push(mergeField(fieldsMap[key]));
  });
  return mergedFields;
};
